import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { getUploadUrl } from '../services/api';
import { getUser, refreshUser } from '../services/auth';
import toast from '../services/toast';
import { parseDataSQL } from '../utils/dataJogo';
import './Premiacoes.css';

function formatData(d) {
  return parseDataSQL(d).toLocaleDateString('pt-BR');
}

export default function Premiacoes() {
  const navigate = useNavigate();
  const [user, setUser] = useState(getUser());
  const [premiacoes, setPremiacoes] = useState([]);
  const [ganhadores, setGanhadores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    refreshUser().then(setUser).catch(() => {});
    Promise.all([
      api.get('/premiacoes'),
      api.get('/premiacoes/ultimos-ganhadores'),
    ]).then(([p, g]) => {
      setPremiacoes(p);
      setGanhadores(g);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  async function resgatar(id) {
    try {
      await api.post('/premiacoes/resgatar', { premiacao_id: id });
      toast.success('Prêmio resgatado! Aguarde o contato do administrador.');
      const [p, u] = await Promise.all([api.get('/premiacoes'), refreshUser()]);
      setPremiacoes(p);
      setUser(u);
    } catch (err) {
      toast.error(err.message);
    }
  }

  if (loading) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div>
      <div className="premiacoes-header">
        <h1 className="page-title">Premiações</h1>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate('/meus-premios')}>Meus Prêmios</button>
      </div>
      <div className="pts-info">Saldo para resgate: <strong>{user?.saldo_resgate ?? user?.pontos ?? 0} pts</strong></div>

      {premiacoes.map(p => {
        const esgotado = p.estoque !== null && p.estoque !== undefined && p.estoque <= 0;
        const saldo = user?.saldo_resgate ?? user?.pontos ?? 0;
        const temPontos = saldo >= p.pontuacao_necessaria;
        const podeResgatar = temPontos && !esgotado;

        return (
          <div key={p.id} className={`premiacao-card${podeResgatar ? ' disponivel' : ''}${esgotado ? ' esgotado' : ''}`}>
            <div className="premiacao-icon">
              {p.imagem
                ? <img src={getUploadUrl(p.imagem)} alt={p.nome} className="premiacao-img" />
                : (esgotado ? '🚫' : '🎁')
              }
            </div>
            <div className="premiacao-info">
              <span className="premiacao-nome">{p.nome}</span>
              {p.descricao && <span className="premiacao-desc">{p.descricao}</span>}
              <span className="premiacao-pts">{p.pontuacao_necessaria} pontos necessários</span>
              {p.estoque !== null && p.estoque !== undefined && (
                <span className={`premiacao-estoque${esgotado ? ' esgotado-txt' : ''}`}>
                  {esgotado ? 'Esgotado' : `${p.estoque} em estoque`}
                </span>
              )}
            </div>
            <button
              className={`btn ${podeResgatar ? 'btn-success' : esgotado ? 'btn-danger' : 'btn-secondary'}`}
              onClick={() => resgatar(p.id)}
              disabled={!podeResgatar}
            >
              {esgotado ? 'Esgotado' : temPontos ? 'Resgatar' : 'Bloqueado'}
            </button>
          </div>
        );
      })}

      {ganhadores.length > 0 && (
        <div className="ganhadores-section">
          <h2 className="sub-title">🏆 Últimos Ganhadores</h2>
          {ganhadores.map((g, i) => (
            <div key={i} className="ganhador-item">
              <span className="ganhador-medal">🏆</span>
              <div className="ganhador-info">
                <span className="ganhador-nome">{g.usuario_nome}</span>
                <span className="ganhador-premio">{g.premiacao_nome}</span>
              </div>
              <span className="ganhador-data">{formatData(g.data_resgate)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
